module.exports = __webpack_public_path__ + "static/media/whatif.47f40748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/whatif.svg
// module id = 97
// module chunks = 0